// invitation/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#8D765B'
      // main: '#7f5539'
    },
    secondary: {
      main: '#9083B8', // セカンダリーカラー
    },
    background: {
      default: '#EEE5DA', 
    },
    card: {
      default: '#FBF8F5'
    },
    text: {
      primary: '#72574E',
      secondary: '#83746F',
    },
    groom: {
      main: '#a28c4a'
    },
    bride: {
      main: '#e97f12'
    },
    undefined: {
      main: '#9E9E9E'
    }
  },
  typography: {
    fontFamily: "'KokuGothic', sans-serif",
    fontSize: 14,
  },
});

export default theme;

